import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = { class: "table-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "result-title" }, "Competitions Details", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "table-header" }, [
              _createElementVNode("th", null, "CompetitionID"),
              _createElementVNode("th", null, "Competition Name"),
              _createElementVNode("th", null, "Start Date"),
              _createElementVNode("th", null, "End Date"),
              _createElementVNode("th", null, "Ticket Count"),
              _createElementVNode("th", null, "Total Tickets Sold"),
              _createElementVNode("th", null, "Tickets Available")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.competitionList)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.competitionList, (competition) => {
                  return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                    _createElementVNode("td", null, _toDisplayString(competition.competitionId), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.competitionName), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.startDate), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.endDate), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.ticketCount), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.totalTicketsSold), 1),
                    _createElementVNode("td", null, _toDisplayString(competition.ticketsAvailable), 1)
                  ]))
                }), 256))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}